import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import ClassroomTabs from './Tabs';
import { fetchApi } from '../../services/api';
import * as moment from 'moment';
import { saveAs } from 'file-saver';

type Props = RouteComponentProps<{
    classroomId: string;
}>;

type State = {
    classroomId: number;
    schedules: Schedule[];
    isLoading: boolean;
}

type Schedule = {
    Name: string;
    Year: number;
    Month: number;
}

export default class ClassroomSchedule extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            classroomId: 0,
            schedules: [],
            isLoading: false,
        };

        this.getSchedules = this.getSchedules.bind(this);
        this.downloadSchedule = this.downloadSchedule.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        //let classroomId = parseInt(this.props.match.params.classroomId) || 0;
        let classroomId = this.props.match.params.classroomId;
        this.getSchedules(parseInt(classroomId));
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        //let classroomId = parseInt(nextProps.match.params.classroomId) || 0;
        let classroomId = nextProps.match.params.classroomId;
        if (this.state.schedules && this.state.classroomId != parseInt(classroomId)) {
            this.getSchedules(parseInt(classroomId));
        }
    }

    public render() {
        return <div>
            <ClassroomTabs classroomId={this.state.classroomId} history={this.props.history} schedule />
            <br />
            <table className="table">
                <thead>
                    <tr>
                        <th>Schedule Month</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.schedules.map((schedule) => {
                        return <tr>
                            <td><a href="#" onClick={(e) => this.downloadSchedule(e, schedule.Year, schedule.Month)}>{schedule.Name}</a></td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

    private getSchedules(classroomId: number) {
        this.setState({ classroomId });
        var start = moment().add(2, 'months');
        var end = moment().subtract(4, 'months');
        var schedules = new Array<Schedule>();
        while(start > end) {
            schedules.push({
                Name: start.format('MMMM YYYY'),
                Year: start.year(),
                Month: start.month() + 1
            });
            start.subtract(1, 'month');
        }
        this.setState({ schedules });
    }

    private downloadSchedule(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, year: number, month: number) {
        e.preventDefault();

        fetchApi('/api/Reports/MonthlyClassSchedule', {
                ClassroomId: this.state.classroomId,
                Year: year,
                Month: month
            }, 'POST')
            .then((blob: Blob) => {
                var newBlob = new Blob([blob], { type: 'application/pdf' });
                saveAs(newBlob, "MonthlyClassSchedule.pdf");
                this.setState({ isLoading: false });
            }).catch(err => {
                console.log(err.message);
                this.setState({ isLoading: false });
            });
    }
}
